import React from 'react';
import TextField from '@mui/material/TextField';
import StaticDateRangePicker from '@mui/lab/StaticDateRangePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import getWindowDimensions from 'Helper';
import { Controller, useFormContext } from 'react-hook-form';
//checkout date range picker with out reactformHooks
export default function CustomDatePicker({ name, onAccept }) {
  const { control } = useFormContext()
  const { width } = getWindowDimensions()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className="" >
          {
            width <= 360 ? null : (
              <form className="w-full relative grid grid-cols-2">
                <input
                  type="text"
                  placeholder="Start date"
                  className="border-b p-3 w-full outline-none"
                  value={value ? dayjs(value[0]).format('DD MMM, YYYY') : ''}
                  readOnly
                />
                <input
                  type="text"
                  placeholder="End date"
                  className="border-b p-3 w-full outline-none"
                  value={value ? dayjs(value[1]).format('DD MMM, YYYY') : ''}
                  readOnly
                />
                {/* <UilTimes 
                  className="absolute top-1 right-1 md:top-3.5 md:right-3.5 text-default" 
                  onClick={reset(name, [null, null])}
                /> */}
              </form>
            )
          }



          <LocalizationProvider dateAdapter={AdapterDateFns} >
            <StaticDateRangePicker
              displayStaticWrapperAs={width > 360 ? 'desktop' : 'mobile'}
              value={value ?? [null, null]}
              onChange={onChange}
              onAccept={onAccept}
              renderInput={(startProps, endProps) => (
                <React.Fragment>
                  <TextField {...startProps} />
                  <Box sx={{ mx: 2 }}> to </Box>
                  <TextField {...endProps} />
                </React.Fragment>
              )}
            />
          </LocalizationProvider>
        </div>
      )}
    />
  );
}
